import { Splide } from '@splidejs/splide';

(function (){
    const carouselElement = document.getElementById('jsGamesSlider');
    if (!carouselElement) return;

    // 1) Initialize the carousel with manual interval
    const carousel = new bootstrap.Carousel(carouselElement, { interval: false });
    const AUTO_INTERVAL = 8000;
    let progressBarInterval;

    // 2) Grab your dots and slide‑name display
    const dots = document.querySelectorAll('.hero-slider__pagination-dot');
    const slideNameEl = document.getElementById('slide-name');

    // 3) Helper: clear & restart auto‑advance
    function resetAutoAdvance() {
        clearInterval(progressBarInterval);
        progressBarInterval = setInterval(() => carousel.next(), AUTO_INTERVAL);
    }

    // 4) Helper: activate dot & slide name
    function activateDot(i) {
        dots.forEach((dot, idx) => dot.classList.toggle('active', idx === i));
        slideNameEl.innerText = dots[i].dataset.name;
    }

    // 5) Attach dot click‑handlers **once**
    dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
            carousel.to(i);          // move to slide i
            activateDot(i);          // update the dot UI & name
            resetAutoAdvance();      // restart auto‑advance
        });
    });

    // 6) Listen for carousel events to keep dots & name in sync
    carouselElement.addEventListener('slid.bs.carousel', (e) => {
        const newIndex = e.to;
        activateDot(newIndex);
        resetAutoAdvance();
    });

    // 7) Kick off the auto‑advance loop
    resetAutoAdvance();

    // 8) Make sure initial state is correct
    activateDot(0);
})();






// Select all containers of the interactive ping-ai elements
document.querySelectorAll('.js-ping-ai-interactive').forEach(container => {
    container.addEventListener('click', function() {
        // Find all image steps and message paragraphs within the container.
        const steps = container.querySelectorAll('.ping-steps');
        const messages = container.querySelectorAll('.typing-animation__text');

        // Get the index of the current active image and text, defaulting to -1 if none active.
        const currentStepIndex = Array.from(steps).findIndex(img => img.classList.contains('active'));
        const currentMessageIndex = Array.from(messages).findIndex(msg => msg.classList.contains('active'));

        // Calculate the next indices (cycle back to the start as needed).
        const nextStepIndex = (currentStepIndex + 1) % steps.length;
        const nextMessageIndex = (currentMessageIndex + 1) % messages.length;

        if (nextStepIndex !== 0) {
            // Remove active classes from the current image and message.
            if (currentStepIndex !== -1) {
                steps[currentStepIndex].classList.remove('active');
            }
            if (currentMessageIndex !== -1) {
                messages[currentMessageIndex].classList.remove('active');
                // Remove any inline animation styles from the span to reset animation state.
                const innerSpan = messages[currentMessageIndex].querySelector('span');
                if (innerSpan) {
                    innerSpan.style.animation = 'none';
                    void innerSpan.offsetWidth; // Force reflow.
                    innerSpan.style.animation = '';
                }
            }

            // Activate the next image.
            steps[nextStepIndex].classList.add('active');

            // Activate the corresponding text message.
            const nextMessage = messages[nextMessageIndex];
            nextMessage.classList.add('active');
            // Reset its inner span animation.
            const nextInnerSpan = nextMessage.querySelector('span');
            if (nextInnerSpan) {
                nextInnerSpan.style.animation = 'none';
                void nextInnerSpan.offsetWidth;
                nextInnerSpan.style.animation = '';
            }
        }

    });
});

new Splide('.js-hero-slider', {
    type: 'loop',
    perPage: 1,
    perMove: 1,
    arrows: false,
    // arrows: {prev: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/></svg>', next: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/></svg>'},
    gap: '1.5rem',
    pagination: false,
    padding: {right: '10%', left: '10%'},
    autoplay: true,
    interval: 3000,
    pauseOnHover: true,
    pauseOnFocus: true,
    mediaQuery: 'min',
    breakpoints: {
        768: {
            perPage: 2,
        },
        992: {
            perPage: 3,
        },
        1200: {
            perPage: 3,
        },
        1400: {
            perPage: 5,
        }
    },
}).mount();

new Splide('.js-community-slider', {
    type: 'loop',
    perPage: 1,
    perMove: 1,
    arrows: false,
    // arrows: {prev: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/></svg>', next: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/></svg>'},
    gap: '1.5rem',
    pagination: false,
    padding: {right: '10%', left: '10%'},
    autoplay: true,
    interval: 3000,
    pauseOnHover: true,
    pauseOnFocus: true,
    mediaQuery: 'min',
    breakpoints: {
        768: {
            perPage: 2,
        },
        992: {
            perPage: 3,
        },
        1200: {
            perPage: 3,
        },
        1400: {
            perPage: 5,
        }
    },
}).mount();
